module.exports = __webpack_public_path__ + "static/media/logo-grundfos.38d778ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logo-grundfos.png
// module id = 1480
// module chunks = 0